import { render, staticRenderFns } from "./SimpleCatalogForm.vue?vue&type=template&id=49f07812&"
import script from "./SimpleCatalogForm.vue?vue&type=script&lang=js&"
export * from "./SimpleCatalogForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCatalogForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports